import { Button } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import { useState } from 'react';
import TagManager from 'react-gtm-module';
import { useTranslation } from 'react-i18next';
import useApi from 'src/hooks/useApi';
import { useSearchAgents } from 'src/hooks/useSearchAgents';
import { useUser } from 'src/hooks/useUser';
import ApiService from 'src/modules/api-service';
import { isSystemAgent } from 'src/modules/system-agents';

import SearchAgentSaveDialog from './SearchAgentSaveDialog';

// Ported from `src/components/SearchAgentSave.tsx`

const SearchAgentSave = ({ control, onSaveAndCreatePurchaseAgent }: any) => {
  const { t } = useTranslation();
  const { data: searchAgents, refetch } = useSearchAgents();
  const { data: user } = useUser();
  const authProvider = user?.user?.authenticationProvider ?? '';
  const userId = user?.user?.id ?? '';
  const userSearchAgents = (searchAgents ?? []).filter(
    (agent) => !isSystemAgent(agent.searchAgentDisplayName, authProvider, userId),
  );
  const [open, setOpen] = useState(false);
  const { fetch: fetchCreate } = useApi();
  const { fetch: fetchUpdate } = useApi();

  return (
    <>
      <Button size="small" color="primary" onClick={() => setOpen(true)} endIcon={<Save />}>
        {t('carsTableNext.carsTableNextFilter.buttonSaveSearchAgent.label')}
      </Button>
      <SearchAgentSaveDialog
        open={open}
        filterControl={control}
        searchAgents={userSearchAgents}
        onClose={() => setOpen(false)}
        onCreate={async (searchAgent) => {
          TagManager.dataLayer({ dataLayer: { event: 'searchagent-save' } });
          const result = await fetchCreate(
            ApiService.searchAgent.searchAgentControllerCreateSearchAgent({
              ...searchAgent,
              version: '2',
            }),
          );
          return result?.data as string | undefined;
        }}
        onUpdate={async (id, searchAgent) => {
          await fetchUpdate(ApiService.searchAgent.searchAgentControllerUpdateSearchAgent(id, searchAgent));
        }}
        refetch={refetch}
        onSaveAndCreatePurchaseAgent={onSaveAndCreatePurchaseAgent}
      />
    </>
  );
};

export default SearchAgentSave;
